import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';

const LanguageTestOverview = (props) => {
  const count = 24;
  const minutes = 15;

  return (
    <div>
      <h3 className={classnames(baseStyles.title_small, baseStyles.text_success, baseStyles.left, baseStyles.mb_15)}>Language test</h3>
      <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
        <li>There are <b>{count}</b> multiple choice questions.</li>
        <li><b>Only one</b> answer is correct.</li>
        <li>You will <b>not be able to either pause or restart</b> the test.</li>
        <li>You will need to <b>answer all the questions</b> before the <br /> time ({minutes} minutes) runs out.</li>
      </ul>
    </div>
  );
};

export default LanguageTestOverview;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/LanguageTestOverview.js